import { Card } from '@mantine/core';
import { IconCoin } from '@tabler/icons-react';
import { useGetModalSectionBorderColor } from 'hooks/useGetModalSectionBorderColor';
import { Section, SectionProps } from './Section';

export const ClaimTariffSection = ({
  index,
  title,
  keys,
  cols,
  editComponentsMap,
  type = 'edit',
}: SectionProps) => {
  const borderColor = useGetModalSectionBorderColor({
    keys,
  });

  return (
    <Card
      padding={'md'}
      shadow="xs"
      radius="md"
      withBorder
      style={{ borderColor: borderColor }}
    >
      <Section
        index={index}
        title={title}
        icon={<IconCoin size={20} />}
        keys={keys}
        cols={cols}
        editComponentsMap={editComponentsMap}
        type={type}
        hideLabel={true}
      />
    </Card>
  );
};
